import { get } from '@alltrails/shared/api';
import { TrailId } from 'types/Trails';

type PropsResponse = {
  initialMyListItems: any;
  initialMyLists: any;
};

// API under app/controllers/api/alltrails/default/trails/props_controller

export default async function getTrailProps(trailId: TrailId, explore?: boolean) {
  return get<PropsResponse>(`/api/alltrails/trails/${trailId}/props`, {
    params: {
      explore
    }
  });
}
